import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { AppointmentResponse, Salon, Service } from 'api/api.types'
import { getSalonsIndex, getServicesIndex } from 'src/store/data.store'

export type PopulatedAppointment = Omit<AppointmentResponse, 'salon' | 'services'> & {
  salon: Salon | null,
  services: Array<Partial<Service> & AppointmentResponse['services'][number]>,
}

/** Adds the salon and the catalogue service data to appointments from the API */
export const usePopulatedAppointments = (appointments: AppointmentResponse[]): PopulatedAppointment[] => {
  const servicesIndex = useSelector(getServicesIndex)
  const salonsIndex = useSelector(getSalonsIndex)
  return useMemo(() => {
    if (!servicesIndex || !salonsIndex) {
      return []
    }
    return appointments.map((a) => ({
      ...a,
      salon: salonsIndex[a.salonId] ?? null,
      services: a.services.map((s) => ({
        ...servicesIndex[s.id],
        ...s,
      })),
    }))
  }, [appointments, servicesIndex, salonsIndex])
}
